var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item1_box"},[(!_vm.yxStatus)?_c('div',{staticClass:"tip"},[_c('span',[_vm._v("系统消息提醒：")]),_c('span',{staticClass:"tip_text"},[_vm._v("您好，"+_vm._s(_vm.user.dwmc)+"，您的会员证书已失效，请您按时缴纳相关费用恢复身份，感谢您的支持！")])]):_vm._e(),_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{style:({
        filter: _vm.yxStatus ? '' : 'saturate(9%)',
        height: _vm.contentHeight,
      }),attrs:{"src":_vm.user.crturl}})]),(!_vm.yxStatus)?_c('div',{staticClass:"mask"},[_c('div',[_vm._v("证书已过期")])]):_vm._e(),_c('vipLogin',{ref:"vipbox"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }